module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-eofy.ba0c3395.jpg";